import * as Immutable from 'immutable';
import { ContentConverter } from './ContentConverter';
import { ContentTypeServerEnum } from './ContentItem';
import { convertToNavigationRestrictionWithAutoProgress } from './propertiesConverter';
import { convertModalSizeFromServerModel } from './PropertiesServerModel';
import { RestrictionConverter } from './restrictionConverter';
import { convertArrowFromServerModel } from './ArrowServerModel';
import { HotspotTabHelper } from '../content/HotspotTab';
import { HotspotHelper } from '../content/Hotspot';
export const convertToHotspot = (serverModel, parentId) => {
    const tabs = serverModel.hotspotTabs.map((t) => convertToHotspotTab(t, parentId));
    const tabIds = Immutable.List(tabs.map((t) => t.id));
    const hotspot = HotspotHelper.build({
        position: convertArrowFromServerModel(serverModel.position),
        parentId,
        trackingIdentifier: serverModel.trackingIdentifier,
        tabs: tabIds,
        modalSize: convertModalSizeFromServerModel(serverModel === null || serverModel === void 0 ? void 0 : serverModel.properties),
        id: serverModel.guid,
    });
    return {
        hotspot,
        tabs,
    };
};
export const convertToHotspotTab = (t, parentId) => {
    const convertedContent = ContentConverter.convertToDomainModel(t.content);
    return HotspotTabHelper.build({
        title: t.title,
        content: convertedContent,
        restriction: convertToNavigationRestrictionWithAutoProgress(t.properties),
        trackingIdentifier: t.trackingIdentifier,
        audioAsset: t.audioAsset,
        id: t.guid,
        referenceIdentifier: t.referenceIdentifier,
        parentId: parentId,
    });
};
export const convertHotspotTabToUpdateServerModel = (item) => {
    return {
        guid: item.id,
        title: item.title,
        content: ContentConverter.convertToServerModel(item.content),
        audioAsset: item.audioAsset,
        properties: {
            navigation: RestrictionConverter.toServerModel(item.restriction),
        },
        referenceIdentifier: item.referenceIdentifier,
    };
};
export const convertHotspotTabToCreateServerModel = (item, parentId) => {
    return {
        ...convertHotspotTabToUpdateServerModel(item),
        itemType: ContentTypeServerEnum.HotspotTab,
        parentId: parentId,
        trackingIdentifier: item.trackingIdentifier,
    };
};
